import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Form from './Form';
import Col from '../layout/Col';
import Row from '../layout/Row';
import Icon from './Icon';
import { generateId } from '../utility/functions';


const Wrapper = styled(Col)`
    gap: 0;
`

const SnapTo = styled.div`
    width: 100%;
    height: 2em;
`
const Drag = styled(Row)`
    position: absolute;
    width: 100%;

    transition: ${({ dragging }) => !dragging ? 'all 0.3s ease-in-out' : ';'}
`


const OrderedInput = ({ onOrderChange, children, ...props }) => {
    const boardRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [draggingPos, setDraggingPos] = useState(0);

    const [lineHeight, setLineHeight] = useState(null);
    const [clickOffset, setClickOffset] = useState(0);

    useEffect(() => {
        if (!dragging) return;

        const handleMouseUp = () => {
            setDraggingPos(null);
            setDragging(null);
        };

        const handleMouseMove = (event) => {
            if (!boardRef.current) return
            const parentRect = boardRef.current.getBoundingClientRect();
            const offsetY = event.clientY - parentRect.top;
            setDraggingPos(offsetY - clickOffset);
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [dragging]);


    const [boardState, setBoardState] = useState(children.map((content, index) => ({
        id: generateId(),
        content,
        index,
    })));


    useEffect(() => setLineHeight(boardRef.current.getBoundingClientRect().height / children.length), [])


    useEffect(() => {
        if (!dragging) return;
        const position = Math.round(draggingPos / lineHeight)
        const input = boardState.find(e => e.id === dragging).index

        if (!(position < children.length) || position < 0) return;

        if (position < children.length && input !== position) {
            const newState = [...boardState];
            const movingInput = newState.find(e => e.id === dragging);
            const savedIndex = movingInput.index;
            const movedInput = newState.find(e => e.index === position);

            movingInput.index = position;
            movedInput.index = savedIndex;
            setBoardState(newState)

            if (onOrderChange) {
                const callbackObj = [...newState];
                onOrderChange(callbackObj.sort((a, b) => a.index - b.index))
            }
        }
    }, [draggingPos]);

    return (
        <div ref={boardRef}>
            <Wrapper {...props}>
                {boardState.map(({ index, content, id }) => (
                    <SnapTo
                        index={index}
                        key={id}
                        style={dragging ? { userSelect: 'none' } : {}}
                        {...props}
                    >
                        <Drag
                            dragging={dragging === id}
                            style={{ top: dragging === id && draggingPos ? draggingPos : (lineHeight * index) }}
                        >
                            <Icon
                                icon='bars'
                                style={{ cursor: 'grab' }}
                                onMouseDown={(e) => {
                                    const coords = e.target.parentElement.getBoundingClientRect();
                                    setClickOffset(e.clientY - coords.top)
                                    setDragging(id)
                                }}
                            />
                            {content}
                        </Drag>
                    </SnapTo>
                ))}
            </Wrapper>
        </div>
    );
}


export default OrderedInput;